export default "__VITE_ASSET__75660a10__"